import script from "./AgentsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentsMain.vue?vue&type=script&setup=true&lang=js"

import "./AgentsMain.vue?vue&type=style&index=0&id=1d503864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d503864"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.1.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBanner,QFab});
